import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { DeviceService, SdBorderWrapperComponent, SdFormRadioGroupComponent, SdHtmlComponent, SdTitleComponent } from '@seb/web-design-system/core';

import type { IShippingMethods } from './shipping-methods.interface';

@Component({
  selector: 'sd-shipping-methods',
  templateUrl: './shipping-methods.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  styleUrls: ['./shipping-methods.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdBorderWrapperComponent,
    SdTitleComponent,
    SdFormRadioGroupComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SdHtmlComponent
  ]
})
export class SdShippingMethodsComponent implements OnInit {
  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly deviceService: DeviceService,
  ) {}

  mobileSubscription: Subscription;
  isMobile$: boolean;

  @Input()
  shippingMethods: IShippingMethods;

  @Input()
  title: string;

  @Input()
  titleLevel = 4;

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }
}
